module.exports = __webpack_public_path__ + "da265930ba862ac9a573bca41d3a09b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipements/acier_inoxydable.png
// module id = h22a
// module chunks = 0